import React, { useMemo } from "react";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import { RevisionRequestsTab } from "./RevisionRequestsTab";
import { useRevisionRequestsPendingCount } from "./RevisionRequestsTab";
import { RevisionUploadsTab } from "./RevisionUploadsTab";
import { useRevisionRequests } from "../hooks/useRevisionRequests";
import type { EvaluationRevisionSupplier } from "../types/revision-review.type";

interface LeadRevisionsViewProps {
	evaluationId: number;
	rfxId: number;
}

export const LeadRevisionsView: React.FC<LeadRevisionsViewProps> = ({
	rfxId,
	evaluationId,
}) => {
	const pendingCount = useRevisionRequestsPendingCount(rfxId, evaluationId);
	const { data: requests } = useRevisionRequests(rfxId, evaluationId);

	const suppliers: EvaluationRevisionSupplier[] = useMemo(() => {
		if (!requests) {
			return [];
		}
		const seen = new Map<number, EvaluationRevisionSupplier>();
		for (const req of requests) {
			if (!seen.has(req.rfx_invite_id)) {
				seen.set(req.rfx_invite_id, {
					id: req.rfx_invite_id,
					name: req.supplier.name,
				});
			}
		}
		return Array.from(seen.values());
	}, [requests]);

	return (
		<Tabs data-testid="lead-revisions-tabs" isLazy>
			<TabList>
				<Tab data-testid="tab-revision-requests">
					Revision Requests{pendingCount > 0 && ` (${pendingCount})`}
				</Tab>
				<Tab data-testid="tab-revision-uploads">
					Revision Uploads
				</Tab>
			</TabList>
			<TabPanels>
				<TabPanel data-testid="tab-panel-revision-requests" className="px-0">
					<RevisionRequestsTab
						rfxId={rfxId}
						evaluationId={evaluationId}
					/>
				</TabPanel>
				<TabPanel data-testid="tab-panel-revision-uploads" className="px-0">
					<RevisionUploadsTab
						rfxId={rfxId}
						evaluationId={evaluationId}
						suppliers={suppliers}
					/>
				</TabPanel>
			</TabPanels>
		</Tabs>
	);
};
